declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    cardList: true;
  }
}

export default function Card() {
  return {
    MuiCard: {
      variants: [
        {
          props: { variant: "cardList" },
          style: {
            margin: 0,
            position: 'relative',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
          },
        },
      ],

      styleOverrides: {
        root: {
        },
      },
    },
  };
}
